import React, { useEffect } from 'react'
import { useOutletContext } from 'react-router'

export default React.memo(function FullscreenPage() {
  const pageContext: any = useOutletContext()

  useEffect(() => {
    pageContext.setFullscreen(true)
    return () => pageContext.setFullscreen(false)
  }, [])

  return null
})
